<template>
  <v-dialog
    v-model="isLoading"
    persistent
    width="400"
    content-class="elevation-0"
  >
    <v-card
      color="transparent"
      flat
    >
      <v-img
        aspect-ratio="16/9"
        height="80"
        :src="require('@/assets/logo_mini.png')"
        contain
      />
      <v-card-text
        class="text-center font-weight-bold"
        style="font-size: 20px; color: white"
      >
        <v-progress-linear
          indeterminate
          color="primary"
        />
        {{ msg }}
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    name: 'LoaderDialogApp',
    computed: {
      isLoading () {
        return this.$store.state.loader.show
      },
      msg () {
        return this.$store.state.loader.msg
      },
    },
  }
</script>
